import { InputWrap, MyStyledInput, MyError } from './styles';
import { useFormikContext, Field, FieldProps, FormikValues } from 'formik';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

export interface InputProps {
	nameData: string;
	label?: string;
	isDisabled?: boolean;
}

const InputHours = (props: InputProps) => {
	const { nameData, label, isDisabled } = props;
	const { setFieldValue } = useFormikContext<FormikValues>();

	return (
		<>
			<Field name={nameData}>
				{({ meta, field }: FieldProps) => (
					<InputWrap>
						{label && <label>{label}</label>}
						<MyStyledInput
							selected={field.value}
							maxDate={moment().toDate()}
							onChange={date => {
								setFieldValue(nameData, date);
							}}
							dateFormat="yyyy-MM-dd"
							timeCaption="Hora"
							className={meta.touched && meta.error ? 'error' : ''}
						/>
						{meta.touched && meta.error && !isDisabled && <MyError>{meta.error}</MyError>}
					</InputWrap>
				)}
			</Field>
		</>
	);
};

export default InputHours;
